import React, { useEffect, useState } from "react";
import "./style.css";
import api from "../../utilis/api";
import { toast } from "react-toastify";
const initialStudents = [
  {
    id: 1,
    name: "John Smith",
    email: "john.smith@gmail.com",
    phone: "2025550101",
    img: "https://i.pravatar.cc/150?img=1",
    active: true,
  },
  {
    id: 2,
    name: "Emily Johnson",
    email: "emily.johnson@gmail.com",
    phone: "2025550102",
    img: "https://i.pravatar.cc/150?img=2",
    active: false,
  },
  {
    id: 3,
    name: "Michael Brown",
    email: "michael.brown@gmail.com",
    phone: "2025550103",
    img: "https://i.pravatar.cc/150?img=3",
    active: true,
  },
  {
    id: 4,
    name: "Jessica Williams",
    email: "jessica.williams@gmail.com",
    phone: "2025550104",
    img: "https://i.pravatar.cc/150?img=4",
    active: true,
  },
  {
    id: 5,
    name: "David Miller",
    email: "david.miller@gmail.com",
    phone: "2025550105",
    img: "https://i.pravatar.cc/150?img=5",
    active: false,
  },
  {
    id: 6,
    name: "Sarah Davis",
    email: "sarah.davis@gmail.com",
    phone: "2025550106",
    img: "https://i.pravatar.cc/150?img=6",
    active: true,
  },
  {
    id: 7,
    name: "Christopher Wilson",
    email: "christopher.wilson@gmail.com",
    phone: "2025550107",
    img: "https://i.pravatar.cc/150?img=7",
    active: false,
  },
  {
    id: 8,
    name: "Amanda Taylor",
    email: "amanda.taylor@gmail.com",
    phone: "2025550108",
    img: "https://i.pravatar.cc/150?img=8",
    active: true,
  },
  {
    id: 9,
    name: "Matthew Anderson",
    email: "matthew.anderson@gmail.com",
    phone: "2025550109",
    img: "https://i.pravatar.cc/150?img=9",
    active: true,
  },
  {
    id: 10,
    name: "Olivia Thomas",
    email: "olivia.thomas@gmail.com",
    phone: "2025550110",
    img: "https://i.pravatar.cc/150?img=10",
    active: false,
  },
];

const Students = () => {
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState("");

  const getStudents = async () => {
    try {
      const response = await api.get("/user?role=student");

      setStudents(response.data.data);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  useEffect(() => {
    getStudents();
  }, []);

  const handleDelete = async (id) => {
    try {
      const res = await api.delete(`/user/${id}`, {
        headers: { "Content-Type": "application/json" },
      });

      if (res) {
        toast.success("Student Deleted Successfully");
        getStudents();
      }
    } catch (error) {
      toast.error("Student Not Deleted");
    }
  };

  const handleActive = async (id, status) => {
    try {
      const res = await api.put(
        `/user/${id}`,
        {
          accountverified: !status,
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      if (res) {
        toast.success("Status Updated");
        getStudents();
      }
    } catch (error) {
      toast.error("Status Not Updated");
    }
  };

  const filteredStudents = students.filter((s) =>
    `${s.name} ${s.email} ${s.phone}`
      .toLowerCase()
      .includes(search.toLowerCase()),
  );
  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    return names
      .map((n) => n[0]?.toUpperCase())
      .join("")
      .slice(0, 2); // Max 2 letters
  };
  return (
    <div className="overview-container">
      <header className="overview-header">
        <div className="header-text">
          <span className="header-subtitle">Welcome Back, Robert</span>
          <h1 className="header-title">All Students</h1>
        </div>
        <div className="user-profile">
          {/* Profile Icon or search can go here */}
        </div>
      </header>
      {/* SEARCH BAR */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Search by name, email, phone..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* TABLE */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredStudents.length > 0 ? (
              filteredStudents.map((student) => (
                <tr key={student._id}>
                  <td>
                    {student.img ? (
                      <img
                        src={student.img}
                        alt={student.name}
                        className="teacher-avatar"
                      />
                    ) : (
                      <div className="teacher-avatar avatar-fallback">
                        {getInitials(student.name)}
                      </div>
                    )}
                  </td>
                  <td>{student.name}</td>
                  <td>{student.email}</td>
                  <td>{student.phone}</td>

                  {/* TOGGLE */}
                  <td>
                    <button
                      className={`status-btn ${
                        student.accountverified ? "active" : "blocked"
                      }`}
                      onClick={() =>
                        handleActive(student._id, student.accountverified)
                      }
                    >
                      {student.accountverified ? "Active" : "Blocked"}
                    </button>
                  </td>

                  {/* ACTIONS */}
                  <td>
                    {/* <button className="edit-btn">Edit</button> */}
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(student._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="no-data">
                  No students found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Students;
